<style scoped>
.iframe-sty {
    width: 100%;
    border: none;
    height: 600px;

}

.flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
}

.pdt100 {
    padding-bottom: 100px !important;
}

.header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;

}

.header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
}

.import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
}

.import-title.second {
    margin-top: 4px;
}

.header .title {
    text-align: center;
    flex: 1;
}

.customer-information {
    background: #fff;
    padding-bottom: 15px;
}

.customer-information .sub-title {
    text-align: left;
    font-size: 14px;
    padding: 10px 16px;
}

.sub-operate-add {
    color: #4FA1A4;
    margin-left: 14px;
    cursor: pointer;
}

.customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
}

.customer-information .col-itms {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    margin-right: 16px;
}

.customer-information .col-itms.second {
    margin-left: 170px;
}

.customer-information .col-itms .title span {
    color: red;
}

.import-new-wrap {
    padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 170px;

}

.import-new-wrap .col-itms {
    align-items: baseline;
}

.operte-btns {
    background: #fff;
    margin-top: 4px;
    display: flex;
    justify-content: center;
    padding: 25px 0;

}

.operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;

}

.operte-btns .btn.save {

    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
}

.operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;

}

.content-main-box {
    height: auto !important;
}

.search-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.search-wrap .input-search {
    width: 200px;
}
</style>

<template>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back" @click="$router.go(-1)">返回</div>
            <div class="title">请假申请</div>
        </div>
        <div class="import-title">申请信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>请假类型</div>
                    <el-select v-model="form.leaveType" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in leaveTypeList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>开始日期</div>
                    <el-date-picker class="w300" type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
                        v-model="form.leaveStartTime"></el-date-picker>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span>*</span>结束日期</div>
                    <el-date-picker class="w300" type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
                        v-model="form.leaveEndTime"></el-date-picker>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>请假时长(天)</div>
                    <el-input class="w300" disabled v-model="timeDuration"></el-input>
                </div>

            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>请假理由</div>
                    <el-input rows="4" class="w300" type="textarea" maxlength="200" placeholder="请填写"
                        v-model="form.leaveReason"></el-input>
                </div>
            </div>
        </div>
        <div class="import-title">上传照片</div>
        <div class="customer-information">
            <div class="import-new-wrap">
                <div class="cols">
                    <div class="col-itms" style="align-items: flex-start;">
                        <div class="title"><span style="color:#fff;">*</span>照片上传</div>
                        <el-upload class="upload-demo t-left" action="#" ref="createProject" :file-list="form.attaches"
                            accept=".jpg,.png,jpeg" :auto-upload="true" list-type="picture-card"
                            :http-request="changeMainFile">

                            <div slot="file" slot-scope="{file}">
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                <span class="el-upload-list__item-actions">
                                    <span disabled class="el-upload-list__item-preview"
                                        @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>

                                    <span disabled @click="handleMainRemove(file)" class="el-upload-list__item-delete">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                </div>
                <div class="import-step-tip">当前支持jpg、png、jpeg格式文件，单个文件不得大于5M</div>
            </div>
        </div>
        <div class="operte-btns">
            <div class="btn cancel" @click="$router.go(-1)">取消</div>

            <div class="btn submit" @click="saveReq">确定</div>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            dialogVisible: false,
            dialogImageUrl: '',
            fullscreenLoading: false,
            leaveTypeList: [
                {
                    label: '事假',
                    value: '1'
                },
                {
                    label: '病假',
                    value: '2'
                },
                {
                    label: '年假',
                    value: '3'
                },
                {
                    label: '产假',
                    value: '4'
                },
                {
                    label: '婚假',
                    value: '5'
                },
                {
                    label: '丧假',
                    value: '6'
                },
                {
                    label: '陪产假',
                    value: '7'
                },
                {
                    label: '调休假',
                    value: '8'
                },
                {
                    label: '哺乳假',
                    value: '9'
                }
            ],
            guid: '',
            form: {
                guid: this.$route.query.guid || null,
                tenantGuid: "",
                tenantName: "",
                staffGuid: "",
                staffName: "",
                mobileNo: "",
                organisationGuid: "",
                organisationName: "",
                leaveType: [],
                leaveStartTime: "",
                leaveEndTime: '',
                leaveReason: "",
                accountMonth: '',
                attaches: []
            }

        }
    },
    computed: {
        timeDuration() {
            if (this.form.leaveStartTime && this.form.leaveEndTime) {
                if (this.form.leaveEndTime == this.form.leaveStartTime) {
                    return '1天';
                } else if (Date.parse(this.form.leaveEndTime) < Date.parse(this.form.leaveStartTime)) {
                    this.form.leaveEndTime = '';
                    this.$message.error('结束时间不能早于开始时间');
                    return '0天';
                } else {
                    return ((Date.parse(this.form.leaveEndTime) - Date.parse(this.form.leaveStartTime)) / (24 * 60 * 60 * 1000) + 1) + '天'
                }
            } else {
                return '0天';
            }

        }
    },
    created() {
        this.getDetail();

    },
    methods: {

        changeMainFile(file) {
            let isLt5M = file.file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 5MB');
                this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('fileName', file.file.name);
            this.fullscreenLoading = true;
            this.api.postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.form.attaches.push({
                        name: file.file.name,
                        url: res.data.data.data,
                    });
                    console.log(this.form.attaches)
                    this.$message({
                        message: '上传成功',
                        type: 'success',
                    });
                }
            }).catch(() => {
                this.$message('上传失败！');
            });

        },
        handleMainRemove(file) {
            let attaches = this.form.attaches;
            attaches.forEach((item, index) => {
                if (item.url == file.url) {
                    attaches.splice(index, 1)
                }
            })
            this.form.attaches = attaches;
            console.log(file);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        getDetail() {
            let self = this;
            if (!this.$route.query.guid) return;
            self.api.get(`/${serverConfig.msSalesPerformService}/leave/detail/${this.$route.query.guid}`).then((
                res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    let data = res.data.data;
                    this.form = {
                        guid: this.$route.query.guid,
                        tenantGuid: data.tenantGuid,
                        tenantName: data.tenantName,
                        staffGuid: data.staffGuid,
                        staffName: data.staffName,
                        mobileNo: data.mobileNo,
                        organisationGuid: data.organisationGuid,
                        organisationName: data.organisationName,
                        leaveType: data.leaveType + "",
                        leaveStartTime: this.$moment(data.leaveStartTime).format('YYYY-MM-DD'),
                        leaveEndTime: this.$moment(data.leaveEndTime).format('YYYY-MM-DD'),
                        leaveReason: data.leaveReason,
                        attaches: data.attaches,
                        accountMonth: data.accountMonth,

                    }
                    let attaches = [];
                    data.attaches&&data.attaches.forEach(itme => {
                        attaches.push({
                            name: itme.fileName,
                            url: itme.path
                        })
                    })
                    this.form.attaches = attaches;
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        checkForm() {
            if (!this.form.leaveType) {
                this.$message.error('请假类型不能为空')
                return false;
            }
            if (!this.form.leaveStartTime) {
                this.$message.error('开始日期不能为空')
                return false;
            }
            if (!this.form.leaveEndTime) {
                this.$message.error('结束日期不能为空')
                return false;
            }
            if (!this.form.leaveReason) {
                this.$message.error('请假理由不能为空')
                return false;
            }

            return true;
        },
        saveReq() {
            if (!this.checkForm()) return;
            let reqUrl = `/${serverConfig.msSalesPerformService}/leave/add`
            let req = JSON.parse(JSON.stringify(this.form));
            let attaches = [];
            req.attaches.forEach(itme => {
                attaches.push({
                    fileName: itme.name,
                    path: itme.url
                })
            })
            req.attaches = attaches;
            req.leaveStartTime = req.leaveStartTime + ' 00:00:00';
            req.leaveEndTime = req.leaveEndTime + ' 00:00:00';
            req.isApprove = 'N';
            this.fullscreenLoading = true;
            if (!this.$route.query.guid) {
                this.api.postJson(reqUrl, req).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        this.$message({
                            message: '新增成功',
                            type: 'success',
                        });
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            } else {
                reqUrl = `/${serverConfig.msSalesPerformService}/leave/update`
                this.api.put(reqUrl, req).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {

                        this.$message({
                            message: '修改成功',
                            type: 'success',
                        });
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });

            }


        }
    }
};
</script> 